export enum HospitalPrescriptionStatus {
  Approved = 1,
  ApprovedPendingPickup = 2,
  PendingVeterinarianApproval = 3,
  Declined = 4,
  Cancelled = 5,
  Transferred = 6,
  Recalled = 7,
  TransferredPermanent = 8,
}

export namespace HospitalPrescriptionStatus {
  export const statusFormattedName = (status: string | number | undefined) => {
    if (typeof status === 'number') status = HospitalPrescriptionStatus[status];
    if (!status) return 'Unknown';

    switch (status) {
      case 'ApprovedPendingPickup':
        return 'Approved - Pending Pickup';
      case 'PendingVeterinarianApproval':
        return 'Pending Veterinarian Approval';
      case 'TransferredPermanent':
        return 'Transferred - Permanent';
      default:
        return status; // Approved, Declined
    }
  };
}
